import keyMirror from "keymirror";


function generateActions(actions) {
  const actionMap = {};
  for (const i in actions) {
    const action = actions[i];
    // Legacy action types
    actionMap[action] = null;
    actionMap[`${action}`] = null;
    actionMap[`${action}_DONE`] = null;
    actionMap[`${action}_FAIL`] = null;

    // New actions should be of the format
    actionMap[`${action}_REQUEST`] = null;
    actionMap[`${action}_SUCCESS`] = null;
    actionMap[`${action}_FAILURE`] = null;

  }
  return keyMirror(actionMap);
}

export default generateActions([
  "RESET_PASSWORD",
  "SET_PASSWORD",
  "UPLOAD_AVATAR",
  "APP_LOAD",
  "FETCH_BASE_STATE",
  "SIGNUP",
  "LOGIN",
  "LOGOUT",
  "FETCH_FLATPAGES",
  "EMAIL_VERIFICATION",
  "SEND_VERIFICATION_EMAIL",
  "FETCH_ORGANIZATIONS",
  "FETCH_COLLAGE_ORGANIZATIONS",
  "FETCH_ORGANIZATION",
  "FETCH_ORGANIZATION_CLAIM",
  "FETCH_FEATURED_ORGANIZATIONS",
  "SAVE_ORGANIZATION_CLAIM",
  "SAVE_ORGANIZATION",
  "VERIFY_RECAPTCHA",
  "FETCH_REGIONS",
  "FETCH_USER",
  "FETCH_MY_INTERESTS",
  "SAVE_MY_INTERESTS",
  "FETCH_MY_FAVORITES",
  "FETCH_FAVORITE_ORGANIZATIONS",
  "ADD_FAVORITE",
  "DELETE_FAVORITE",
  "SAVE_ME",
  "GO_TO_SURVEY",
  "SAVE_RECOMMENDED_RESOURCE",
  "FETCH_MY_SUGGESTIONS",
  "FETCH_NOTIFICATIONS",
  "FETCH_NOTIFICATION",
  "MARK_NOTIFICATION_READ",
  "MARK_ALL_NOTIFICATIONS_READ",
  "SAVE_ORGANIZATION_APPLICATION",
  "START_ONBOARDING",
  "UPDATE_ONBOARDING_STEPS",
  "UPDATE_REGION_FILTER",
  "SAVE_USER_INFO_STEP",
  "FETCH_CATEGORY_BANNER_SLIDER_COLLECTION",
  "FETCH_KEYWORD_SEARCH_RESULTS",
  "SEARCH_AUTOCOMPLETE",
  "BROWSER_GEOLOCATION",
  "SERVER_GEOLOCATION",
  "CITY_AUTOCOMPLETE",
  "FETCH_HOMESTORIES",
  "FETCH_STORY",
  "FETCH_FEATURED_HOME_ORGANIZATIONS",
  "FETCH_HOME_BANNER_FEATURED_ORGANIZATIONS",
  "FETCH_BFW_ORGANIZATIONS",
  "SAVE_BFW_APPLICATION",
  "UPDATE_BFW_APPLICATION",
  "FETCH_FESTIVAL_EVENT_CATEGORIES",
  "OPEN_SIGNUP_FORM",
  "CLOSE_SIGNUP_FORM",
  "OPEN_LOGIN_FORM",
  "CLOSE_LOGIN_FORM",
  "FETCH_BFW_OFFERS",
  "FETCH_BFW_OFFERS_FEATURED",
  

  "SAVE_LEADER_STORY",
  "UPLOAD_LEADER_STORY_PHOTO",
  "FETCH_LEADER_STORIES",
  "FETCH_LEADER_STORY",

  "SAVE_SHARED_STORY",
  "UPDATE_SHARED_STORY",
  "UPLOAD_SHARED_STORY_PHOTO",
  "FETCH_SHARED_STORIES",
  "FETCH_SHARED_STORY",
  "FETCH_FESTIVAL_NEWS",
  "FETCH_FESTIVAL_PROGRAM_LP",
  "FETCH_FESTIVAL_EVENTS",
  "FETCH_FEATURED_ORGS_SLIDER",
  "FETCH_FEATURED_ORGS_FROM_DB",
  "FETCH_ORGS_BY_TYPE",
  "FETCH_SPONSORSHIP_CATEGORIES",
  "FETCH_FESTIVAL_SPONSOR_BY_CATEGORY",
  "FETCH_CATEGORY_EVENTS",
  "FETCH_TIMES_EVENTS",
  "FETCH_FESTIVAL_PROGRAM_EVENTS_BY_CATEGORY",
  "FETCH_STORIES_BY_CATEGORY",
  "FETCH_STORY_CATEGORY_NAMES",
  "FETCH_STORIES_BY_CATEGORY_ROOT",
  "FETCH_SPONSORS",
  "FETCH_HOME_PAGE_CATEGORIES",
  "FETCH_HOME_PAGE_NEWSLETTERS",
  "FETCH_NEWSLETTER",
]);



// WEBPACK FOOTER //
// ./src/actions/actionTypes.js